<template>
    <div class="add_to_cart_wrap" :class="[extraClasses, {'has_input': showQuantityInput}]">

        <input name="quantity_input" v-if="isEnabled && showQuantityInput" type="number" min="1" max="9999" v-model="quantity" v-on:change="quantityOnChange" 
            v-on:focus="handleInputFocus" v-on:blur="handleInputBlur"/>
        
        <select name="quantity_options" v-if="isEnabled && showQuantityInput && selectOnMobile" v-model="quantity" v-on:change="quantityOnChange">
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
        </select>    

        <button v-if="isEnabled" v-on:click.prevent.stop="addToCart" class="pd_button pd_add"
            :class="[isLoading ? 'loading' : '']"
            :disabled="buttonDisabled">
            <div class="awaiting_overlay partial dots_loader">
                <p loader="loading" class="variant"></p>
            </div>
            <span class="add_to_cart_button_text" v-text="addToCartText"></span> 
        </button>

        <a v-if="isEnabled === false && contactYourLocationUrl" class="pd_button pd_add" :href="contactYourLocationUrl" target="_self">{{options.labels.contactYourLocation}}</a>

        <div id="added_to_cart" class="added_to_cart_popup variant" ref="popup" v-bind:class="[{'shown' : addedToCartPopupShow}]">
            <div class="container">
                <div class="atc_body">
                    <template v-if="addToCartErrorOccured">
                        <div class="atc_title">Error occured, please try again later</div>
                    </template>
                    <template v-else>
                        <div class="atc_title">{{options.labels.addedToYourCart}}</div>
                        <div class="atc_data">
                            <div v-if="imageUrl" class="atc_image">
                                <img :src="imageUrl" :data-static="thumbnailStaticUrl"
                                    onerror="this.src=this.dataset.static"/>
                            </div>
                            <div class="atc_product">
                                <div class="atc_name">{{product.name}}</div>
                                <pricing-info :show="showPrice" :price-object="productPricing" :show-old="false" extra-classes="atc_price"></pricing-info>
                            </div>
                        </div>
                        <a v-if="cartDetailsUrl" class="atc_viewcart" :href="cartDetailsUrl" target="_self">{{options.labels.viewCart}}({{productsTotalQuantity}})</a>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import cardMixin from "../mixins/card-mixin";
    import popupMixin from "../mixins/popup-mixin";
    import { Constants } from "../functions/constants";
    import { CartUtils } from "../functions/cart-utils";
    import PricingInfo from "./PricingInfo";
    import { ArrayUtils } from "../functions/array-utils";
    import { NumberUtils } from "../functions/number-utils";

    const defaultLabels = {
        "addedToYourCart": "Added to your cart",
        "keepShopping": "Keep shopping",
        "checkout": "Checkout",
        "viewCart": "View Cart",
        "close": "Close",
        "addToCart": "Add To Cart",
        "addedToCart": "Added To Cart"
    }

    const DEFAULT_QUANTITY = 1;

    export default {
        name: "AddToCart",
        mixins: [cardMixin, popupMixin],
        components: { PricingInfo },
        props: {
            showQuantityInput: {
                type: Boolean,
                default: false
            },
            product: {
                type: Object,
                default: {}
            },
            productPricing: {
                type: Object,
                default: {}
            },
            extraClasses: {
                type: String,
                default: ''
            },
            cartDetailsUrl: {
                type: String,
                default: ''
            },
            contactYourLocationUrl: {
                type: String,
                default: ''
            },
            imageUrl: {
                type: String,
                default: ''
            },
            options: {
                type: Object,
                default: {
                    labels: defaultLabels
                }
            },
            buttonDisabled: {
                type: Boolean,
                default: false
            },
            selectOnMobile: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                addedToCartPopupShow: false,
                cartDetail: CartUtils.getCartDetailsTemplate(),
                quantity: DEFAULT_QUANTITY,
                isBusinessCustomer: false,
                isOnlineBranch: false,
                myStore: {},
                isLoading: false,
                addToCartErrorOccured: false,
                tempQuantity: 1
            }
        },
        methods: {
            cartDetailsUpdatedEventHandler: function (object, cartDetail) {
                this.cartDetail = CartUtils.getCartDetailsDecorated(cartDetail);
            },
            addToCart: function () {
                var that = this;

                var entityId = this.entityId;               

                this.isLoading = true;
                GlobalApp.EventHub.raiseEvent(Constants.EVENTS.ADD_TO_CART_PROCESSING_ON);

                if (!this.quantity)
                    this.quantity = 1;

                GlobalApp.CartService
                    .addCartItem(this.quantity, entityId, this.sku)
                    .then(function (data) {
                        if (data.Error) {
                            that.addToCartErrorOccured = true
                        }
                        else {
                            that.$emit('addedtocart');
                            that.pushAddToCartData(that.product, that.quantity);
                        }
                        that.showAddedToCartPopup();
                        that.isLoading = false;
                    });
            },
            showAddedToCartPopup: function () {
                this.isLoading = false;
                if (this.addedToCartPopupShow) {
                    return;
                }
                    
                GlobalApp.EventHub.raiseEvent(Constants.EVENTS.CLOSE_ALL_POPUPS);
                GlobalApp.EventHub.raiseEvent(Constants.EVENTS.POPUP_OPENED);
                this.addedToCartPopupShow = true;
                this.liftPopupSection(true)
            },
            pushAddToCartData: function (product, qty) {
                const price = product.prices?.price.value ?? 0;
                const brand = typeof product.brand === 'object' ? product.brand.name : product.brand;
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    'event': 'add_to_cart',
                    'ecommerce': {
                        'currency': product.prices?.price.currencyCode ?? 'USD',
                        'value': (price * qty),
                        'items': [{ 'item_id': product.sku, 'item_name': product.name, 'item_brand': brand, 'price': price, 'quantity': qty }]
                    }
                });
            },
            handleInputFocus: function() {
                this.tempQuantity = this.quantity;
                this.quantity = null;
            },
            handleInputBlur: function() {
                if(!this.quantity) {
                    this.quantity = this.tempQuantity;
                    this.tempQuantity = 1;
                }
            },
            closeAddedToCartPopup: function () {
                this.isLoading = false;

                if (!this.addedToCartPopupShow)
                    return;

                this.addedToCartPopupShow = false;
                this.liftPopupSection(false);
                this.addToCartErrorOccured = false;
                GlobalApp.EventHub.raiseEvent(Constants.EVENTS.ADD_TO_CART_PROCESSING_OFF);
            },
            closeAllPopupsHandler: function () {
                this.closeAddedToCartPopup()
                this.isLoading = false;
            },
            myStoreUpdateEventHandler: function (object, myStore) {
                this.myStore = myStore;
            },
            quantityOnChange: function () {
                var parsedQuantity = NumberUtils.tryParse(this.quantity);
                if (!parsedQuantity || parsedQuantity < 1) {
                    this.quantity = DEFAULT_QUANTITY;
                    return;
                }

                this.quantity = parsedQuantity;
            }
        },
        computed: {
            model: function () {
                return {
                    customDict: this.product
                };
            },
            addToCartText: function () {
                if (this.addedToCartPopupShow) {
                    return defaultLabels.addedToCart
                } else {
                    return defaultLabels.addToCart
                }
            },
            isEnabled: function () {
                const hasPrice = this.productPricing && this.productPricing.main;

                if (this.isParts && !hasPrice) {
                    return false;
                }

                if (this.isPartWithSpecialAORValidation === false)
                    return true;

                let productLine = this.productLineWithValidation();

                if (productLine) {
                    if (this.isOnlineBranch && Constants.PRODUCT_LINES_WITH_99_LOGIN_EXCEPTION_VALIDATION.includes(productLine))
                        return true;  
                    else if (this.isBusinessCustomer && !Constants.PRODUCT_LINES_WITH_99_LOGIN_EXCEPTION_VALIDATION.includes(productLine))
                        return true;                        
                    else if (Constants.PRODUCT_LINES_WITH_UNRESTRICTED_LOGIN_VALIDATION.includes(productLine))
                        return true;  
                }

                return false;
            },
            showPrice: function () {
                return this.shouldShowPrice(this.isBusinessCustomer);
            },
            popupShown: function () {
                return this.addedToCartPopupShow
            },
            productsTotalQuantity: function () {
                return CartUtils.getProductsTotalQuantity(this.cartDetail);
            }
        },
        watch: {
            addedToCartPopupShow(newValue, oldValue) {
                if (newValue && !oldValue) {
                    setTimeout(() => {
                        this.closeAddedToCartPopup()
                    }, 3000)
                }
            }
        },
        async created() {
            if (!this.cartDetailsUrl && this.options ?.cartDetailsUrl)
                this.cartDetailsUrl = this.options ?.cartDetailsUrl;

            if (!this.contactYourLocationUrl && this.options ?.contactYourLocationUrl)
                this.contactYourLocationUrl = this.options ?.contactYourLocationUrl;

            this.isBusinessCustomer = await GlobalApp.CustomerService.isCurrentCustomerWithBusinessAccountType();
            this.myStore = await GlobalApp.MyStoreService.getMyStore();
            GlobalApp.MyStoreService.isMyStoreOnlineBranch().then(this.updateIsOnlineBranch);

            GlobalApp.EventHub.subscribeToEvent(Constants.EVENTS.CART.CART_DETAILS_UPDATE, this.cartDetailsUpdatedEventHandler);
            GlobalApp.EventHub.subscribeToEvent(Constants.EVENTS.CLOSE_ALL_POPUPS, this.closeAllPopupsHandler);
            GlobalApp.EventHub.subscribeToEvent(Constants.EVENTS.CART.MY_STORE_UPDATE, this.myStoreUpdateEventHandler);
        },
        destroyed() {
            GlobalApp.EventHub.unsubscribeToEvent(Constants.EVENTS.CART.CART_DETAILS_UPDATE, this.cartDetailsUpdatedEventHandler);
            GlobalApp.EventHub.unsubscribeToEvent(Constants.EVENTS.CLOSE_ALL_POPUPS, this.closeAllPopupsHandler);
            GlobalApp.EventHub.unsubscribeToEvent(Constants.EVENTS.CART.MY_STORE_UPDATE, this.myStoreUpdateEventHandler);
        }
    };
</script>